import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { LegalSection } from "@/components/legal/LegalSection";

const tableOfContents = [
  { id: "gioi-thieu", title: "Giới thiệu", level: 1 },
  { id: "tieu-chuan-cong-dong", title: "Tiêu chuẩn cộng đồng", level: 1 },
  { id: "noi-dung-cam", title: "Nội dung bị cấm", level: 1 },
  { id: "phat-ngon-ghet", title: "Chính sách phát ngôn thù địch", level: 2 },
  { id: "quay-roi", title: "Quấy rối và bắt nạt", level: 2 },
  { id: "noi-dung-tinh-duc", title: "Nội dung tình dục và trẻ em", level: 2 },
  { id: "hoat-dong-bat-hop-phap", title: "Hoạt động bất hợp pháp", level: 2 },
  { id: "spam", title: "Spam và hành vi không chân thực", level: 2 },
  { id: "thuc-thi", title: "Thực thi và hậu quả", level: 1 },
  { id: "bao-cao", title: "Báo cáo vi phạm", level: 1 },
  { id: "do-tuoi", title: "Xếp hạng độ tuổi và hạn chế", level: 1 },
  {
    id: "hop-tac-phap-luat",
    title: "Hợp tác với cơ quan thực thi pháp luật",
    level: 1,
  },
  { id: "cap-nhat", title: "Cập nhật hướng dẫn", level: 1 },
  { id: "lien-he", title: "Thông tin liên hệ", level: 1 },
];

export default function CommunityGuidelinesVietnamese() {
  return (
    <LegalPageLayout
      title="Hướng dẫn Cộng đồng & EULA"
      lastUpdated="8 tháng 1, 2025"
      language="vi"
      alternateUrl="/community-guidelines"
      tableOfContents={tableOfContents}
    >
      <LegalSection id="gioi-thieu" title="Giới thiệu">
        <p>
          Chào mừng bạn đến với Locuno, một nền tảng mạng xã hội kết nối mọi
          người trong các cộng đồng địa phương. Hướng dẫn Cộng đồng và Thỏa
          thuận Cấp phép Người dùng Cuối (EULA) này thiết lập các quy tắc và
          tiêu chuẩn điều chỉnh việc sử dụng nền tảng của chúng tôi.
        </p>
        <p>
          Bằng cách sử dụng Locuno, bạn đồng ý tuân thủ các hướng dẫn này và
          hiểu rằng các vi phạm có thể dẫn đến việc xóa nội dung ngay lập tức và
          chấm dứt tài khoản. Các hướng dẫn này áp dụng cho tất cả người dùng,
          nội dung và tương tác trên nền tảng của chúng tôi.
        </p>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4">
          <p className="text-amber-800 font-medium">
            <strong>Hạn chế độ tuổi:</strong> Locuno có xếp hạng 17+. Người dùng
            phải ít nhất 17 tuổi để tạo tài khoản và sử dụng dịch vụ của chúng
            tôi.
          </p>
        </div>
      </LegalSection>

      <LegalSection id="tieu-chuan-cong-dong" title="Tiêu chuẩn cộng đồng">
        <p>
          Locuno cam kết tạo ra một môi trường an toàn, tôn trọng và bao dung
          cho tất cả các thành viên cộng đồng. Nền tảng của chúng tôi được thiết
          kế để kết nối hàng xóm và xây dựng các cộng đồng địa phương mạnh mẽ
          hơn thông qua các tương tác tích cực.
        </p>
        <p>Chúng tôi mong đợi tất cả người dùng:</p>
        <ul>
          <li>Đối xử với người khác bằng sự tôn trọng và tử tế</li>
          <li>Chia sẻ thông tin chân thực và trung thực</li>
          <li>Tôn trọng quyền riêng tư và ranh giới cá nhân</li>
          <li>Tuân thủ luật pháp và quy định địa phương</li>
          <li>Đóng góp tích cực vào các cuộc thảo luận cộng đồng</li>
          <li>Báo cáo nội dung không phù hợp khi gặp phải</li>
        </ul>
      </LegalSection>

      <LegalSection id="noi-dung-cam" title="Nội dung bị cấm">
        <p>
          Các loại nội dung và hành vi sau đây bị nghiêm cấm trên Locuno và sẽ
          dẫn đến hành động ngay lập tức đối với tài khoản của bạn:
        </p>
      </LegalSection>

      <LegalSection
        id="phat-ngon-ghet"
        title="Chính sách phát ngôn thù địch"
        level={2}
      >
        <p>
          <strong>Chính sách không khoan nhượng:</strong> Locuno hoàn toàn không
          khoan nhượng với bất kỳ loại phát ngôn thù địch nào. Điều này bao gồm
          nhưng không giới hạn ở:
        </p>
        <ul>
          <li>
            Nội dung tấn công cá nhân hoặc nhóm dựa trên chủng tộc, dân tộc, tôn
            giáo, giới tính, khuynh hướng tình dục, khuyết tật hoặc quốc tịch
          </li>
          <li>
            Ngôn ngữ phân biệt đối xử, lời lẽ xúc phạm hoặc thuật ngữ xúc phạm
          </li>
          <li>
            Nội dung thúc đẩy tư tưởng thượng đẳng hoặc quan điểm cực đoan
          </li>
          <li>
            Biểu tượng, hình ảnh hoặc tham chiếu liên quan đến các nhóm thù địch
          </li>
        </ul>
        <p>
          <strong>Hậu quả:</strong> Chấm dứt tài khoản ngay lập tức và vĩnh
          viễn. Không có cảnh báo nào được đưa ra cho các vi phạm phát ngôn thù
          địch.
        </p>
      </LegalSection>

      <LegalSection id="quay-roi" title="Quấy rối và bắt nạt" level={2}>
        <p>
          Quấy rối, bắt nạt và đe dọa không có chỗ đứng trong cộng đồng của
          chúng tôi. Các hành vi bị cấm bao gồm:
        </p>
        <ul>
          <li>Quấy rối có mục tiêu đối với cá nhân hoặc nhóm</li>
          <li>Bắt nạt trên mạng, bao gồm liên lạc không mong muốn liên tục</li>
          <li>Doxxing hoặc chia sẻ thông tin cá nhân mà không có sự đồng ý</li>
          <li>Đe dọa bạo lực hoặc gây hại</li>
          <li>Các chiến dịch quấy rối có tổ chức</li>
          <li>Theo dõi hoặc chú ý không mong muốn liên tục</li>
        </ul>
        <p>
          <strong>Hậu quả:</strong> Đình chỉ hoặc chấm dứt tài khoản ngay lập
          tức tùy thuộc vào mức độ nghiêm trọng.
        </p>
      </LegalSection>

      <LegalSection
        id="noi-dung-tinh-duc"
        title="Nội dung tình dục và trẻ em"
        level={2}
      >
        <p>
          <strong>Cấm tuyệt đối mọi nội dung tình dục:</strong> Locuno hoàn toàn
          cấm bất kỳ nội dung tình dục nào, bao gồm nhưng không giới hạn ở hình
          ảnh, video, văn bản hoặc mô tả có tính chất tình dục rõ ràng. Chúng
          tôi duy trì một nền tảng sạch sẽ, tập trung vào cộng đồng và gia đình.
        </p>
        <p>
          <strong>Đặc biệt nghiêm trọng:</strong> Bất kỳ nội dung tình dục nào
          liên quan đến trẻ vị thành niên đều bị nghiêm cấm và sẽ được báo cáo
          ngay lập tức cho cơ quan thực thi pháp luật. Điều này bao gồm:
        </p>
        <ul>
          <li>
            Bất kỳ nội dung tình dục hóa nào có sự tham gia của cá nhân dưới 18
            tuổi
          </li>
          <li>
            Hành vi dụ dỗ hoặc tiếp xúc không phù hợp với trẻ vị thành niên
          </li>
          <li>
            Chia sẻ, yêu cầu hoặc thảo luận về tài liệu tình dục bất hợp pháp
          </li>
          <li>
            Nội dung tình dục hóa hoặc khai thác trẻ em theo bất kỳ cách nào
          </li>
        </ul>
        <p>
          <strong>Nội dung tình dục nói chung:</strong> Ngoài các quy định
          nghiêm khắc về trẻ em, tất cả nội dung tình dục rõ ràng của người lớn
          cũng bị cấm trên nền tảng của chúng tôi. Locuno được thiết kế như một
          không gian cộng đồng an toàn và phù hợp cho mọi lứa tuổi từ 17+.
        </p>
        <p>
          <strong>Hậu quả:</strong> Chấm dứt tài khoản vĩnh viễn ngay lập tức và
          báo cáo cho các cơ quan có thẩm quyền.
        </p>
      </LegalSection>

      <LegalSection
        id="hoat-dong-bat-hop-phap"
        title="Hoạt động bất hợp pháp"
        level={2}
      >
        <p>
          Locuno cấm tất cả các hoạt động bất hợp pháp và nội dung thúc đẩy hoặc
          tạo điều kiện cho hành vi bất hợp pháp, bao gồm:
        </p>
        <ul>
          <li>Buôn bán, bán hoặc phân phối ma túy</li>
          <li>Lừa đảo, lừa gạt hoặc tội phạm tài chính</li>
          <li>Trộm cắp, cướp bóc hoặc tội phạm tài sản</li>
          <li>Bạo lực hoặc đe dọa bạo lực</li>
          <li>Vi phạm bản quyền hoặc trộm cắp sở hữu trí tuệ</li>
          <li>Rửa tiền hoặc các tội phạm tài chính khác</li>
          <li>
            Bất kỳ hoạt động nào vi phạm luật địa phương, quốc gia hoặc quốc tế
          </li>
        </ul>
        <p>
          <strong>Hậu quả:</strong> Chấm dứt tài khoản ngay lập tức và hợp tác
          với cơ quan thực thi pháp luật khi cần thiết.
        </p>
      </LegalSection>

      <LegalSection id="spam" title="Spam và hành vi không chân thực" level={2}>
        <p>
          Để duy trì chất lượng và tính chân thực của cộng đồng, những điều sau
          bị cấm:
        </p>
        <ul>
          <li>Tin nhắn spam, bài đăng hoặc nội dung lặp lại</li>
          <li>Tài khoản giả mạo hoặc mạo danh</li>
          <li>Đăng bài tự động hoặc hoạt động bot</li>
          <li>Thông tin sai lệch hoặc giả mạo</li>
          <li>Tự quảng cáo quá mức hoặc spam thương mại</li>
          <li>Thao túng các tính năng nền tảng hoặc sự tương tác</li>
        </ul>
        <p>
          <strong>Hậu quả:</strong> Xóa nội dung, đình chỉ tài khoản hoặc chấm
          dứt dựa trên mức độ nghiêm trọng và tần suất.
        </p>
      </LegalSection>

      <LegalSection id="thuc-thi" title="Thực thi và hậu quả">
        <p>
          Locuno xem trọng các vi phạm của những hướng dẫn này và sử dụng cả hệ
          thống tự động và đánh giá của con người để phát hiện và giải quyết nội
          dung và hành vi không phù hợp.
        </p>

        <h3>Hành động thực thi</h3>
        <ul>
          <li>
            <strong>Xóa nội dung:</strong> Xóa ngay lập tức các bài đăng, bình
            luận hoặc phương tiện vi phạm
          </li>
          <li>
            <strong>Cảnh báo tài khoản:</strong> Cảnh báo chính thức cho các vi
            phạm nhỏ
          </li>
          <li>
            <strong>Đình chỉ tạm thời:</strong> Hạn chế tạm thời quyền truy cập
            tài khoản
          </li>
          <li>
            <strong>Chấm dứt vĩnh viễn:</strong> Xóa vĩnh viễn tài khoản và tất
            cả dữ liệu liên quan
          </li>
        </ul>

        <h3>Chính sách không kháng cáo</h3>
        <p>
          Đối với các vi phạm nghiêm trọng bao gồm phát ngôn thù địch, quấy rối,
          nội dung tình dục liên quan đến trẻ vị thành niên và hoạt động bất hợp
          pháp, việc chấm dứt tài khoản là cuối cùng và không thể kháng cáo.
        </p>
      </LegalSection>

      <LegalSection id="bao-cao" title="Báo cáo vi phạm">
        <p>
          Các thành viên cộng đồng đóng vai trò quan trọng trong việc duy trì sự
          an toàn của nền tảng. Nếu bạn gặp nội dung hoặc hành vi vi phạm các
          hướng dẫn này:
        </p>
        <ul>
          <li>
            Sử dụng chức năng báo cáo có sẵn trên tất cả bài đăng và hồ sơ
          </li>
          <li>Cung cấp thông tin chi tiết về vi phạm</li>
          <li>Không tương tác hoặc phản hồi với nội dung vi phạm</li>
          <li>
            Đối với các mối quan tâm về an toàn khẩn cấp, liên hệ với chúng tôi
            ngay tại safety@locuno.com
          </li>
        </ul>
        <p>
          Tất cả các báo cáo được xem xét kịp thời, và chúng tôi thực hiện hành
          động thích hợp dựa trên kết quả điều tra của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection id="do-tuoi" title="Xếp hạng độ tuổi và hạn chế">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <p className="text-red-800 font-medium">
            <strong>Xếp hạng độ tuổi 17+:</strong> Locuno được xếp hạng cho
            người dùng từ 17 tuổi trở lên. Xếp hạng này phản ánh bản chất trưởng
            thành của các cuộc thảo luận cộng đồng và trách nhiệm cần thiết cho
            mạng lưới địa phương.
          </p>
        </div>
        <p>Người dùng phải ít nhất 17 tuổi để:</p>
        <ul>
          <li>Tạo tài khoản Locuno</li>
          <li>Truy cập các tính năng nền tảng</li>
          <li>Tham gia vào các cuộc thảo luận cộng đồng</li>
          <li>Sử dụng thị trường và dịch vụ địa phương</li>
        </ul>
        <p>
          Có thể yêu cầu xác minh tuổi, và các tài khoản được phát hiện thuộc về
          người dùng dưới 17 tuổi sẽ bị chấm dứt ngay lập tức.
        </p>
      </LegalSection>

      <LegalSection
        id="hop-tac-phap-luat"
        title="Hợp tác với cơ quan thực thi pháp luật"
      >
        <p>
          <strong>Tuân thủ pháp luật:</strong> Apple và Locuno có thể chia sẻ
          tài liệu vi phạm và thông tin người dùng với các cơ quan thực thi pháp
          luật khi được yêu cầu bởi pháp luật hoặc khi chúng tôi tin rằng cần
          thiết để:
        </p>
        <ul>
          <li>Tuân thủ các quy trình pháp lý hoặc yêu cầu của chính phủ</li>
          <li>Bảo vệ sự an toàn của người dùng hoặc công chúng</li>
          <li>Điều tra hoạt động tội phạm tiềm ẩn</li>
          <li>Ngăn chặn tổn hại đến trẻ vị thành niên</li>
          <li>Giải quyết các mối quan tâm về an ninh quốc gia</li>
        </ul>
        <p>
          Chúng tôi duy trì nhật ký chi tiết về hoạt động và nội dung của người
          dùng nhằm mục đích bảo mật nền tảng và tuân thủ pháp luật. Thông tin
          này có thể được cung cấp cho các cơ quan có thẩm quyền theo yêu cầu
          của luật pháp và quy định hiện hành.
        </p>
      </LegalSection>

      <LegalSection id="cap-nhat" title="Cập nhật hướng dẫn">
        <p>
          Các Hướng dẫn Cộng đồng này có thể được cập nhật định kỳ để giải quyết
          các thách thức mới, yêu cầu pháp lý hoặc thay đổi nền tảng. Người dùng
          sẽ được thông báo về các thay đổi quan trọng thông qua:
        </p>
        <ul>
          <li>Thông báo trong ứng dụng</li>
          <li>Thông báo qua email</li>
          <li>Cập nhật trang này với ngày sửa đổi</li>
        </ul>
        <p>
          Việc tiếp tục sử dụng Locuno sau khi cập nhật hướng dẫn cấu thành sự
          chấp nhận các điều khoản đã sửa đổi.
        </p>
      </LegalSection>

      <LegalSection id="lien-he" title="Thông tin liên hệ">
        <p>
          Để biết thêm câu hỏi về các Hướng dẫn Cộng đồng này hoặc báo cáo vi
          phạm nghiêm trọng, vui lòng liên hệ với chúng tôi:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mt-4">
          <p>
            <strong>Đội An toàn:</strong> safety@locuno.com
          </p>
          <p>
            <strong>Đội Pháp lý:</strong> legal@locuno.com
          </p>
          <p>
            <strong>Hỗ trợ Chung:</strong> support@locuno.com
          </p>
          <p>
            <strong>Địa chỉ:</strong> Cloudjet Solutions Pte. Ltd.
            <br />
            71 Ayer Rajah Crescent
            <br />
            #02-10/11
            <br />
            Singapore 139951
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
          <p className="text-blue-800">
            <strong>Tình huống khẩn cấp:</strong> Đối với các mối quan tâm về an
            toàn ngay lập tức hoặc báo cáo hoạt động bất hợp pháp, hãy liên hệ
            với các cơ quan thực thi pháp luật địa phương ngoài việc thông báo
            cho đội an toàn của chúng tôi.
          </p>
        </div>
      </LegalSection>
    </LegalPageLayout>
  );
}
